import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { ObjectionSection } from '../components/ObjectionSection';
import { BookPresentation } from '../components/BookPresentation';
import { TransformationSection } from '../components/TransformationSection';
import { AudienceSection } from '../components/AudienceSection';
import { AuthoritySection } from '../components/AuthoritySection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferSection } from '../components/OfferSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { EmotionalCTA } from '../components/EmotionalCTA';
import { ClosingSection } from '../components/ClosingSection';
import { SocialProofPopup } from '../components/SocialProofPopup';
export function SalesPage() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-white" data-id="element-254">
      <HeroSection data-id="element-255" />
      <PainSection data-id="element-256" />
      <ObjectionSection data-id="element-257" />
      <BookPresentation data-id="element-258" />
      <TransformationSection data-id="element-259" />
      <AudienceSection data-id="element-260" />
      <AuthoritySection data-id="element-261" />
      <TestimonialsSection data-id="element-262" />
      <OfferSection data-id="element-263" />
      <BonusSection data-id="element-264" />
      <PricingSection data-id="element-265" />
      <EmotionalCTA data-id="element-266" />
      <ClosingSection data-id="element-267" />

      <SocialProofPopup data-id="element-268" />
    </main>;
}